import React, { useEffect, useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import { collection, addDoc, setDoc, doc} from "firebase/firestore"; 
import {ref, uploadBytes, deleteObject, getDownloadURL, getStorage, uploadBytesResumable } from "firebase/storage"
import { db, storage } from "../firebase-config";
import Financeurs from './Financeurs';
import {v4 as uuidv4} from 'uuid'
import { IoMdCamera } from "react-icons/io";
import { FaCircleMinus } from "react-icons/fa6";

const Form = () => {

  
    const [validation, setValidation] = useState("")
    const formRef = useRef()
    const [dataStructure, setDataStructure] = useState("");     
    const [dataContrat, setDataContrat] = useState("");
    const [dataSecteurDactivite, setDataSecteurDactivite] = useState("");
    const [dataIntitule, setDataIntitule] = useState("");
    const [dataMission, setDataMission] = useState("");
    const [dataCompetences, setDataCompetences] = useState("");
    const [dataConditions, setDataConditions] = useState("");
    const [dataContact, setDataContact] = useState("");
    const [dataParticipate, setDataParticipate] = useState("");
    const [dataLogo, setDataLogo] = useState("");

    const [count, setCount] = useState(); 
    const [countSkill, setCountSkill] = useState(); 
    const [validationMessage, setValidationMessage] = useState("")
    const [modal, setModal] = useState(false)
    const [progressPercent, setProgressPercent] = useState(0)
    const [validImageFiles, setImageFiles] = useState([]);
   
    const [secteurDactivite, setSecteurDactivité] = useState()
    const [secteurDactiviteAutre, setSecteurDactivitéAutre] = useState()


    const [images, setImages] = useState([]);
    const maxLenght = 4;
    const imageTypeRegex = /image\/(png|jpg|jpeg)/gm;

    const [options, setOptions] = useState([
      {
        label: "Administration publique",
        value: "Administration publique"
      },
      {
        label: "Agriculture viticulture",
        value: "Agriculture et Viticulture"
      },
      {
        label: "Automobile",
        value: "Automobile"
      },
      {
        label: "Banques et assurances",
        value: "Banques et assurances"
      },
      {
        label: "Bâtiment et travaux public",
        value: "Bâtiment et travaux publics"
      },
      {
        label: "Commerce",
        value: "Commerce"
      },
      {
        label: "Environnement",
        value: "Environnement"
      },
      {
        label: "Café hôtellerie et restauration",
        value: "Café, Hôtellerie et restauration"
      },
      {
        label: "Immobilier",
        value: "Immobilier"
      },
      {
        label: "Industrie",
        value: "Industrie"
      },
      {
        label: "Juridique et comptabilité",
        value: "Juridique et comptabilité"
      },
      {
        label: "Numérique multimédia et communication",
        value: "Numérique, multimédia et communication"
      },
      {
        label: "Sanitaires, social et médical",
        value: "Sanitaires, social et médical"
      },
      {
        label: "Services",
        value: "Services"
      },
      {
        label: "Tourisme et culture",
        value: "Tourisme et culture"
      },
      {
        label: "Transport et logistique",
        value: "Transport et logistique"
      },
      {
        label: "Autre (précisez)",
        value: "Autre (précisez)"
      },
    ])

    const handleOption = async (e) => {
        console.log(e.target.value);
        if(e.target.value !== "Autre (précisez)") {
          setSecteurDactivité(e.target.value)
        } else if(e.target.value === "Autre (précisez)"){
            setModal(true)
            console.log(modal);
            
        }
        
        
    }

    useEffect(() => {
    let sectA = options.filter(option => option.value === secteurDactivite)
    console.log(sectA.length);
    
    if(sectA.length <= 0) {
      setSecteurDactivitéAutre(secteurDactivite)
    } 

    
    console.log(sectA);
    
    }, [secteurDactivite])


    console.log(secteurDactivite);
    const [imgs, setImgs] = useState({
      name: 'no file',
      src: 'no file'
    });

    console.log(options);
    

      //  SUPPRIMER IMAGE 

      let removedImg

      const removeImg = (name) => {
  
        const imgRef = ref(storage, `offresDemploi/2024/logos/${name}`);
  
        
     
        deleteObject(imgRef).then(() => {
          console.log('success');
          }).catch((error) => {
            console.log('error');
            });
            setImgs({
              name: 'no file',
              src: 'no file'
            })
              
            
        }
  


      // RECUPERATION DES IMAGES 
  
  
      const handlePictures = async (e) => {
        const { files } = e.target;
        const validImageFiles = [];
        for (let i = 0; i < files.length; i++) {
          const newImage = e.target.files[i];
          newImage["id"] = Math.random();
          setImages((prevState) => [...prevState, newImage]);
  
          const file = files[i];
          if (file.type.match(imageTypeRegex)) {
            validImageFiles.push(file);
          }
          if (validImageFiles.length > maxLenght) {
            validImageFiles.pop(file);
            alert("Vous ne pouvez pas ajouter plus de 4 images");
        }
  
        console.log(validImageFiles)
  
        }
        if (validImageFiles.length) {
          setImageFiles(validImageFiles);
          return;
        }
        else {
          alert("Le type d'images sélectionné n'est pas valide");
        }
      };
  
  
        const handleUpload = () => {
          const promises = [];
          console.log('imgMap');
          setImgs({
            name: 'no file',
            src: 'no file'
          })
          validImageFiles.map((validFile) => {
  
            const metadata = {
              contentType: 'image/jpeg'
            };
  
            const storageRef = ref(storage, `offresDemploi/2024/logos/${validFile.name}`);
            const uploadTask = uploadBytesResumable(storageRef, validFile, metadata)
            promises.push(uploadTask);
            uploadTask.on(
              "state_changed",
              (snapshot) => {
                const progress = Math.round(
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                
                setProgressPercent(progress);
              },
              (error) => {
                console.log(error);
              },
              async () => { 
                
                getDownloadURL(storageRef).then((urls, name) => {
                  setImgs({name: validFile.name, src: urls});
                });
              
              }
            );
  
            
          
          } ); 
          
      
          Promise.all(promises)
           
            .catch((err) => console.log(err));
            
        };
  
        
        useEffect(() => {
          handleUpload()
        }, [validImageFiles])
        console.log(imgs);
        console.log(validImageFiles);
      
  
  
    const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
          mode: 'onChange',
          defaultValues: "",
    })

    const onSubmit = async data  => {

        var id = uuidv4()
        var structure = "/";     
        var sActivite = "/";
        var contrat = "/";
        var intitule = "/";
        var mission = "/";
        var competences = "/";
        var conditions = "/";
        var contact = "/";
        var seraPresent = "/"
        var logo = "/"
    


                
      if(data.contrat) {
        contrat = data.contrat
        setDataContrat(data.contrat)
      } 
                
      if(data.intitule) {
        intitule = data.intitule
        setDataIntitule(data.intitule)
      } 
      if(secteurDactivite !== undefined) {
        sActivite = secteurDactivite
        setDataSecteurDactivite(secteurDactivite)
      } 
      if(data.mission) {
        mission = data.mission
        setDataMission(data.mission)
      } 
                
      if(data.structure) {
        structure = data.structure.toUpperCase()
        setDataStructure(data.structure)
      } 
                
      if(data.competences) {
        competences = data.competences
        setDataCompetences(data.competences)
      } 
      if(data.conditions) {
        conditions = data.conditions
        setDataConditions(data.conditions)
      } 
      if(data.contact) {
        contact = data.contact
        setDataContact(data.contact)
      }

      if(data.seraPresent) {
        seraPresent = data.seraPresent
        setDataParticipate(data.seraPresent)
      }

      if(imgs.src) {
        logo = imgs.src
        setDataLogo(imgs.src)
      }
 


    try {

        const preSubInfo = {
          ID: id, 
          STRUCTURE: structure,
          SECTEURACTIVITE: sActivite,
          CONTRAT: contrat,
          INTITULE: intitule,
          MISSION: mission,
          COMPETENCES: competences,
          CONDITIONS: conditions,
          CONTACT: contact,
          SERAPRESENT: seraPresent,
          LOGO: logo,
          DATE: new Date().toLocaleString().slice(0, 10)   
        }
        console.log(preSubInfo)

        console.log(data)
        const ref = doc(db, "offreDemploi", 'edition', '2024', id);
        const docRef = setDoc(ref, preSubInfo)
        setValidation(["Votre offre a bien été enregistrée", "Success"])
  

      }
              catch(err) {
              console.log(err);
              setValidation(["Une erreur s'est produite veuillez rééssayer ultérieurement", "Error"])

          }
      
          formRef.current.reset("");
        

          
}
    return (
        <>
         
            <div className="container">

              {modal &&
                <div className="modal">
                  <div className="modalBox">
                    <input onChange={(e) => setSecteurDactivité(e.target.value)} type="text" name="" id="" placeholder="Entrez votre secteur d'activité"/>
                    <p>Il apparaîtra ensuite dans la liste</p>
                    <button className="btn" onClick={() => setModal(false)}>Envoyer</button>
                  </div>
                
                  <div className="overlay" onClick={() => setModal(false)}></div>
                </div>
             }
            
                 <form ref={formRef} id="sign-in" onSubmit={handleSubmit(onSubmit)}>
                    {validation && <div className={ validation[1] === "Success" ? "success" : "error"}>{validation[0]}</div>}
                    {validation[1] === "Success" && <>
                    <div className="recap">
                        <h3>Récapitulatif de votre envoi</h3>
                          <div className='row'>
                              <h4>Structure :</h4>
                              <span>{dataStructure}</span>
                          </div>
                          <div className='row'>
                              <h4>Secteur d'activité :</h4>
                              <span>{dataSecteurDactivite}</span>
                          </div>
                          <div className='row'>
                              <h4>Type de contrat :</h4>
                              <span>{dataContrat}</span>
                          </div>
                          <div className='row'>
                              <h4>Intitulé :</h4>
                              <span>{dataIntitule}</span>
                          </div>
                          <div className='row'>
                              <h4>Mission :</h4>
                              <span>{dataMission}</span>
                          </div>
                          <div className='row'>
                              <h4>Compétences :</h4>
                              <span>{dataCompetences}</span>
                          </div>
                          <div className='row'>
                              <h4>Conditions :</h4>
                              <span>{dataConditions}</span>
                          </div>
                          <div className='row'>
                              <h4>Contact :</h4>
                              <span>{dataContact}</span>
                          </div>
                          {imgs.src !== "no file" &&
                          <div className='row'>
                              <h4>Logo :</h4>
                              <img className="logo" width="250" src={imgs.src} />
                          </div>
                          }

                          {dataParticipate === "Mon organisme sera présent à l’édition 2024 d’Agora Jobs" ? 
                           <span className='participate'>Votre organisme sera présent à l'édition 2024 d'Agora Jobs</span>

                           : 

                           <span className='participate'>Votre organisme ne sera pas présent à l'édition 2024 d'Agora Jobs</span>
                          }
                    </div>
                    </>
                    }    {isSubmitSuccessful === true ? "" :
                    <>

                    <h4 className='required'>Les champs marqués d'un * sont requis</h4>
                        <input {...register('structure', {required: true})} type="text" name="structure" id="" placeholder="Nom de l'entreprise/structure *"/>
                        {errors.structure?.type === "required" && (
                               <small>Ce champ est requis</small>
                          )}

                          <div className="secteurDactivite">
                          <select name="" id="" onChange={(e) => handleOption(e)} >
                            <option value="aucun">Séléctionner un secteur d'activité</option>
                            {options.map(option => {
                              return  <option value={option.value}>{option.label}</option>
                            })}
                            {secteurDactiviteAutre &&
                              <option value={secteurDactiviteAutre}>{secteurDactiviteAutre}</option>
                            }
                          </select>
                          </div>
                        <input {...register('contrat', {required: true})} type="text" name="contrat" id="" placeholder='Type de contrat (CDI, CDD, Contrat de mission...) *'/>
                        {errors.contrat?.type === "required" && (
                               <small>Ce champ est requis</small>
                          )}
                        <input {...register('intitule', {required: true})} type="text" name="intitule" id="" placeholder='Intitulé du poste *' />
                        {errors.intitule?.type === "required" && (
                              <small>Ce champ est requis</small>
                          )}
                        <textarea {...register('mission', {required: true})} name="mission" id="" maxLength="1000" cols="30" rows="5" placeholder='Mission *' onChange={e => setCount(e.target.value.length)}></textarea>
                        <div className="counter">
                          <span className={count < 950 ? "green" : count === 1000 ? "red" : "orange"}>{count}</span>
                        </div>
                        {errors.mission?.type === "required" && (
                              <small>Ce champ est requis</small>
                          )}
                        <textarea {...register('competences', {required: true})} name="competences"  maxLength="500" placeholder='Les compétences requises (savoir-faire, expériences, diplômes...) *' onChange={e => setCountSkill(e.target.value.length)} id="" cols="30" rows="5"></textarea>
                        <div className="counter">
                          <span className={countSkill < 450 ? "green" : countSkill === 500 ? "red" : "orange"}>{countSkill}</span>
                        </div>
                        {errors.competences?.type === "required" && (
                               <small>Ce champ est requis</small>
                          )}
                        <input {...register('conditions', {required: true})} type="text" name="conditions" placeholder='Conditions particulières (travail posté, astreintes, travail le samedi...) *' id="" />
                        {errors.conditions?.type === "required" && (
                              <small>Ce champ est requis</small>
                          )}
                        <input {...register('contact', {required: true})} type="text" name="contact" id="" placeholder='Contact (adresse mail, téléphone ou site web permettant de candidater) *'/>
                        {errors.contact?.type === "required" && (
                               <small>Ce champ est requis</small>
                          )}
                            <div className="row" id="picture_row">
                              <label htmlFor="">Ajouter votre logo</label>
                              <div className="img_row">
                                <div className="add_img_box">
                                <IoMdCamera />
                                <input type="file" name="" id="" onChange={handlePictures} accept="image/png, image/jpeg, image/svg, image/bmp" />
                                </div>
                                {imgs.src !== 'no file' &&
                                  
                                      <div key={uuidv4()} className="img_box">
                                        <div className="remove">
                                          <FaCircleMinus onClick={() => removeImg(imgs.name)} />
                                        </div>
                                        <div className="bkgd"  style={{backgroundImage: `url(${imgs.src})`}}></div>
                                          <img className="actualImg" src={imgs.src} alt="" />
                                      </div> 
                                      
                            
                                }
                        </div>

                
                     </div>
                    <div className="participate">
                        <label htmlFor="">Mon organisme sera présent à l’édition 2024 d’Agora Jobs : *</label>
                        <div className="answers">
                        <input type="radio"  {...register('seraPresent', {required: true})} id="" value="Mon organisme sera présent à l’édition 2024 d’Agora Jobs"/>
                        <label>Oui</label>
                        <input type="radio"  {...register('seraPresent', {required: true})} id="" value="Mon organisme ne sera pas présent à l’édition 2024 d’Agora Jobs"/>
                        <label>Non</label>
                        </div>
                        {errors.seraPresent?.type === "required" && (
                            <small>Ce champ est requis</small>
                          )}
                    </div>
                    
                   
                       <button className="btn" id="button">Envoyer</button>
                      </>
                      }
                    </form>
                    <Financeurs /> 
                </div>
     
        </>
    );
};

export default Form;